import { render, staticRenderFns } from "./DemographicFilterCard.vue?vue&type=template&id=48f4df24&scoped=true"
import script from "./DemographicFilterCard.vue?vue&type=script&lang=js"
export * from "./DemographicFilterCard.vue?vue&type=script&lang=js"
import style0 from "./DemographicFilterCard.vue?vue&type=style&index=0&id=48f4df24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4df24",
  null
  
)

export default component.exports